import { render } from "./Cbhicontactpage.vue?vue&type=template&id=16d4cc4b&scoped=true"
import script from "./Cbhicontactpage.vue?vue&type=script&lang=js"
export * from "./Cbhicontactpage.vue?vue&type=script&lang=js"

import "./Cbhicontactpage.vue?vue&type=style&index=0&id=16d4cc4b&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d4cc4b"]])

export default __exports__